import { createSlice } from '@reduxjs/toolkit';
import { fetchProductList } from '../subscriptionApi';

const fetchProductListSlice = createSlice({
    name: 'subscription/fetchProductList',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchProductList cases
            .addCase(fetchProductList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductList.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchProductList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default fetchProductListSlice.reducer;
